import React from 'react';

export default function Organization() {
  return (
    <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
      <div className="container mx-auto">
        {/* <h1 className="text-2xl font-semibold mb-4">Organizasyon</h1> */}
        {/* Organizasyon içeriği burada olacak */}
      </div>
    </div>
  );
}
